// Familles de rôles de l'alerte « société arrivée » (spec § 11) : mêmes règles que `public.role_family` dans la base.

export type WatchFamily = "owner" | "design" | "contractor" | "other";
export const WATCH_FAMILIES: WatchFamily[] = [
  "owner",
  "design",
  "contractor",
  "other",
];

const FAMILIES: Record<string, WatchFamily> = {
  "Client / Project Owner": "owner",
  Developer: "owner",
  "Project management company": "design",
  "Engineering company": "design",
  "Design consultant": "design",
  Architect: "design",
  "Waterproofing consultant": "design",
  "Concrete consultant": "design",
  "Main contractor": "contractor",
  "General contractor": "contractor",
  "EPC contractor": "contractor",
  "Civil contractor": "contractor",
  "Waterproofing contractor": "contractor",
};

export const roleFamily = (role: string): WatchFamily =>
  FAMILIES[role] ?? "other";

/** Familles suivies par l'utilisateur dont aucune société n'est encore connue sur la fiche. */
export const missingFamilies = (roles: string[], watched: WatchFamily[]) => {
  const known = new Set(roles.map(roleFamily));
  return watched.filter((family) => !known.has(family));
};
